import React, { ReactElement } from 'react';
import { TParagraphBlockData } from '../types';
import Typo from '../../Typography';
import { getHighlightSelectionTipProps } from '../withHighlightSelectionTip';
import { withHighlightAsText } from '../../Highlight/services/withHighlightAsText';
import { parseWithoutNonBreakingSpaces } from '../services/parseWithoutNonBreakingSpaces';
import { HighlightSelectionHint, TParagraphHighlightBlockData } from '../../Highlight/types';

export const renderParagraph = (
  { text, alignment = 'left' }: TParagraphBlockData,
  highlightData?: TParagraphHighlightBlockData,
) => {
  const { text: highlightText } = highlightData || {};
  const elements: string | ReactElement | ReactElement[] = parseWithoutNonBreakingSpaces(
    withHighlightAsText(text, highlightText),
  );

  return (
    <Typo
      variant="article-p"
      text={elements}
      style={{ textAlign: alignment }}
      {...getHighlightSelectionTipProps(HighlightSelectionHint.Text)}
    />
  );
};
